export default __webpack_public_path__ + "static/media/ja3.1b41328b.jpg";